var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramShares40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pictogram/ExtraSmall./Shares40",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("g", {
    id: "pictogram/Shares",
    transform: "translate(7.000000, 11.000000)",
    stroke: "#4F4C4D"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Line",
    strokeLinecap: "square",
    points: "2.33333333 14.875 9.33333333 6.53333333 16.3333333 11.7833333 23.3333333 2.625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1166667,2.625 C21.1166667,1.4 22.1083333,0.408333333 23.3333333,0.408333333 C24.5583333,0.408333333 25.55,1.4 25.55,2.625 C25.55,3.85 24.5583333,4.84166667 23.3333333,4.84166667 C22.1083333,4.84166667 21.1166667,3.85 21.1166667,2.625 Z",
    id: "Point-4",
    fill: "#FFCC00",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1166667,11.7833333 C14.1166667,10.5583333 15.1083333,9.56666667 16.3333333,9.56666667 C17.5583333,9.56666667 18.55,10.5583333 18.55,11.7833333 C18.55,13.0083333 17.5583333,14 16.3333333,14 C15.1083333,14 14.1166667,13.0083333 14.1166667,11.7833333 Z",
    id: "Point-3",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.11666667,6.53333333 C7.11666667,5.30833333 8.10833333,4.31666667 9.33333333,4.31666667 C10.5583333,4.31666667 11.55,5.30833333 11.55,6.53333333 C11.55,7.75833333 10.5583333,8.75 9.33333333,8.75 C8.10833333,8.75 7.11666667,7.75833333 7.11666667,6.53333333 Z",
    id: "Point-2",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.33333333,17.0333333 C1.10833333,17.0333333 0.116666667,16.0416667 0.116666667,14.8166667 C0.116666667,13.5916667 1.10833333,12.6 2.33333333,12.6 C3.55833333,12.6 4.55,13.5916667 4.55,14.8166667 C4.55,16.0416667 3.55833333,17.0333333 2.33333333,17.0333333",
    id: "Point-1",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramShares40);
export default __webpack_public_path__ + "static/media/pictogramShares40.07871ccffa97c82baf4c94c2858b65aa.svg";
export { ForwardRef as ReactComponent };